import PageContainer from '@/components/layout/page-container';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import CreateInquiryForm from '@/modules/help/create-inquiry-form';
import MyInquiries from '@/modules/help/my-inquiries';
import { MessageSquare, HelpCircle } from 'lucide-react';

const HelpPage = () => {
  return (
    <PageContainer>
      <div className='rounded bg-white p-6'>
        <div className='mb-6'>
          <h1 className='text-2xl font-bold text-gray-900'>Help & Support</h1>
          <p className='text-gray-600 mt-1'>Get help or submit feedback to our support team</p>
        </div>

        <Tabs defaultValue='my-inquiries' className='w-full'>
          <TabsList className='inline-flex h-11 items-center justify-center rounded-lg bg-muted p-1 text-muted-foreground w-fit'>
            <TabsTrigger value='my-inquiries' className='inline-flex items-center justify-center whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm'>
              <HelpCircle className='mr-2 h-4 w-4' />
              My Inquiries
            </TabsTrigger>
            <TabsTrigger value='create-inquiry' className='inline-flex items-center justify-center whitespace-nowrap rounded-md px-4 py-2 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm'>
              <MessageSquare className='mr-2 h-4 w-4' />
              Create
            </TabsTrigger>
          </TabsList>

          <TabsContent value='my-inquiries' className='mt-6'>
            <MyInquiries />
          </TabsContent>

          <TabsContent value='create-inquiry' className='mt-6'>
            <CreateInquiryForm />
          </TabsContent>
        </Tabs>
      </div>
    </PageContainer>
  );
};

export default HelpPage;
